export default __webpack_public_path__ + "static/media/uv5.c0fe4de8.svg";